import { combineReducers } from '@reduxjs/toolkit';

import hesReducer from './hes';
import hesApi from './hes/hesApi';

import veeReducer from './vee';
import veeApi from './vee/veeApi';

import authApi from './auth/authApi';
import authReducer from './auth';

import userAccessApi from './user-access-panel/userAccessPanelAPI';
import rfFWApi from './legacy-rf-firmware-upgrade/fwUpgradeApi';

import nfmsReducer from './nfms';
import nfmsApi from './nfms/nfmsApi';
import MDMSFiltersAPI from './mdms-filters/MDMSFiltersAPI';
import satApi from './sat/satApi';

import prepaidEngineReducer from './prepaid-engine';
import prepaidEngineApi from './prepaid-engine/prepaidEngineApi';
import dcuFWApi from './legacy-dcu-firmware-upgrade/dcuUpgradeApi';
import userAccessPanelAPIDLMS from './user-access-panel/DLMSUserAccessPanelAPI';
import energyAccountingApi from './energy-accounting/energyAccountingApi';

const rootReducer = combineReducers({
  hes: hesReducer,
  [hesApi.reducerPath]: hesApi.reducer,

  vee: veeReducer,
  [veeApi.reducerPath]: veeApi.reducer,

  auth: authReducer,
  [authApi.reducerPath]: authApi.reducer,

  [userAccessApi.reducerPath]: userAccessApi.reducer,
  [userAccessPanelAPIDLMS.reducerPath]: userAccessPanelAPIDLMS.reducer,
  [MDMSFiltersAPI.reducerPath]: MDMSFiltersAPI.reducer,

  [rfFWApi.reducerPath]: rfFWApi.reducer,
  [dcuFWApi.reducerPath]: dcuFWApi.reducer,
  [energyAccountingApi.reducerPath]: energyAccountingApi.reducer,
  nfms: nfmsReducer,
  [nfmsApi.reducerPath]: nfmsApi.reducer,

  prepaidEngine: prepaidEngineReducer,
  [prepaidEngineApi.reducerPath]: prepaidEngineApi.reducer,
  [satApi.reducerPath]: satApi.reducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
